import { Button, Form, Input, Select, Switch, Table, message } from "antd";
import { layoutForms, toEnglishDigits } from "../../../component/utility";
/////Redux
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  OfflineCoreServices,
  CallCoreServicesActionWithToken,
} from "../../../appRedux/actions/CoreServicesAction";
import Url from "../../../apiCall/UrlConfig";
import { useEffect, useState } from "react";
const ImagePreAddress = Url.baseURL[0] + Url.downloadImage;
const AssignedPatient = (props) => {
  const [form] = Form.useForm();

  const [listStd, setListStd] = useState([]);
  const [selectedStdId, setSelectedStd] = useState(null);
  const Columns = [
    {
      title: "Assign to Student",
      dataIndex: "maxilla",
      key: "maxilla",
      render: (obj, item, index) => {
        return (
          <div style={{ textAlign: "center" }}>
            <Form.Item name={item.id} valuePropName="checked">
              <Switch />
            </Form.Item>
          </div>
        );
      },
    },
    {
      title: "Age",
      dataIndex: "Age",
      key: "Age",
      render: (obj, item, index) => {
        return <div style={{ textAlign: "center" }}>{item.age}</div>;
      },
    },
    {
      title: "maxilla",
      dataIndex: "maxilla",
      key: "maxilla",
      render: (obj, item, index) => {
        let imageObj = item?.patientImages?.find((o) => o.type == "maxilla");
        let imageSource = ImagePreAddress + imageObj.imageUrl;
        return (
          <>
            <img
              key={obj}
              src={imageSource}
              alt="maxilla"
              style={{ width: "70px" }}
            />
            <div></div>
          </>
        );
      },
    },
    {
      title: "mandible",
      dataIndex: "mandible",
      key: "mandible",
      render: (obj, item, index) => {
        let imageObj = item?.patientImages?.find((o) => o.type == "mandible");
        let imageSource = ImagePreAddress + imageObj.imageUrl;
        return (
          <>
            <img
              key={obj}
              src={imageSource}
              alt="mandible"
              style={{ width: "70px" }}
            />
            <div></div>
          </>
        );
      },
    },
    {
      title: "opg",
      dataIndex: "opg",
      key: "opg",
      render: (obj, item, index) => {
        let imageObj = item?.patientImages?.find((o) => o.type == "opg");
        let imageSource = ImagePreAddress + imageObj.imageUrl;
        return (
          <>
            <img
              key={obj}
              src={imageSource}
              alt="opg"
              style={{ width: "70px" }}
            />
            <div></div>
          </>
        );
      },
    },
    {
      title: "lateral cephalometric ",
      dataIndex: "lateral cephalometric",
      key: "lateral cephalometric",
      render: (obj, item, index) => {
        let imageObj = item?.patientImages?.find((o) => o.type == "laterall");
        let imageSource = ImagePreAddress + imageObj.imageUrl;
        return (
          <>
            <img
              key={obj}
              src={imageSource}
              alt="lateral cephalometric"
              style={{ width: "70px" }}
            />
            <div></div>
          </>
        );
      },
    },
    {
      title: "frontal Photo ",
      dataIndex: "frontal Photo",
      key: "frontal Photo",
      render: (obj, item, index) => {
        let imageObj = item?.patientImages?.find((o) => o.type == "frontal");
        let imageSource = ImagePreAddress + imageObj.imageUrl;
        return (
          <>
            <img
              key={obj}
              src={imageSource}
              alt="frontal"
              style={{ width: "70px" }}
            />
            <div></div>
          </>
        );
      },
    },
    {
      title: "lateral Photo ",
      dataIndex: "lateral Photo",
      key: "lateral Photo",
      render: (obj, item, index) => {
        let imageObj = item?.patientImages?.find(
          (o) => o.type == "lateralphoto"
        );
        let imageSource = ImagePreAddress + imageObj.imageUrl;
        return (
          <>
            <img
              key={obj}
              src={imageSource}
              alt="lateralphoto"
              style={{ width: "70px" }}
            />
            <div></div>
          </>
        );
      },
    },
  ];

  const _getListPatient = async (paging) => {
    let _paging = paging;

    if (paging == null) {
      _paging = {
        pageNumber: 1,
        pageSize: 10,
      };
    }
    let url = Url.GetPatientNotAssigned;

    let res = await props.actions.CallCoreServicesActionWithToken(url, _paging);

    console.log(res);
    if (res.hasError) {
      message.error(res.message);
      return;
    }
  };
  const _getListStudent = async () => {
    let url = Url.getStudentList;

    let res = await props.actions.CallCoreServicesActionWithToken(url, {});

    console.log(res);
    if (res.hasError) {
      message.error(res.message);
      return;
    }

    let _list = res.data.map((o) => {
      return {
        value: o.id,
        label: o.name + "----" + o.numberPatient,
      };
    });

    setListStd(_list);
  };
  useEffect(() => {
    _getListPatient();
    _getListStudent();
  }, []);

  const _onClickRegister = async () => {
    if (selectedStdId == null) {
      message.warn("لطفا یک دانشجو را انتخاب کنید");
      return;
    }

    let _listChecked = form.getFieldsValue();

    let _toserver = [];
    for (var key in _listChecked) {
      if (_listChecked.hasOwnProperty(key)) {
        if (_listChecked[key]) {
          _toserver.push({
            studentId: selectedStdId,
            patientId: parseInt(key),
          });
        }
      }
    }

    if (_toserver.length == 0) {
      message.warn("لطفا یک بیمار را انتخاب کنید");
      return;
    }

    let res = await props.actions.CallCoreServicesActionWithToken(
      Url.SetPatientToStudent,
      _toserver
    );

    if (res.hasError) {
      message.error(res.message);
      return;
    }
    message.success(res.message);
    _getListPatient();
    _getListStudent();
    setSelectedStd(null);
  };

  const _onChangePageSize = (pageNumber, pageSize) => {
    _getListPatient({
      pageNumber,
      pageSize,
    });
  };
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div style={{ alignSelf: "center", width: "80%" }}>
        <Form form={form}>
          <Table
            columns={Columns}
            dataSource={
              props.coreData[Url.GetPatientNotAssigned]?.[Url.action]?.data
                ?.patients
            }
            loading={
              props.coreData[Url.GetPatientNotAssigned]?.[Url.action]
                ?.isFetching
            }
            pagination={{
              total:
                props.coreData[Url.GetPatientNotAssigned]?.[Url.action]?.data
                  ?.totalCount,
              onChange: _onChangePageSize,
            }}
            rowKey={(o) => o.id}
          />
        </Form>

        <div>
          دانشجو
          <Select
            showSearch
            filterOption={(input, option) => {
              input = toEnglishDigits(input);
              return (option?.label ?? "")
                .toLowerCase()
                .includes(input.toLowerCase());
            }}
            value={selectedStdId}
            onChange={(e) => setSelectedStd(e)}
            style={{ width: "50%", marginRight: 30 }}
            options={listStd}
          />
          عدد تعداد بیماران هر دانشجو می باشد
        </div>
        <div style={{ textAlign: "center", marginTop: 40 }}>
          <Button onClick={_onClickRegister} style={{ width: 200 }}>
            ثبت
          </Button>
        </div>
      </div>
    </div>
  );
};

const actionCreators = Object.assign(
  {},
  { CallCoreServicesActionWithToken, OfflineCoreServices }
);
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
});

const mapStateToProps = (state) => ({
  coreData: state.coreservices.coreData,
});

export default connect(mapStateToProps, mapDispatchToProps)(AssignedPatient);
